import React from "react";

const SectionOne = () => {
  return (
    <div className="section-one-container12 py-5">
      <div className="container " style={{ overflow: "hidden" }}>
        <div className="row mt-4 align-items-center">
          {/* LEFT: Image + Overlays */}
          <div className="col-12 col-lg-6 d-flex flex-column  align-items-center position-relative  mb-lg-0">
            <p className="about-us-subtitle-right-column">
              <span className="about-us-line-dashed"></span>
            </p>
            <p className="always-support-text-exact underline mt-5">ABOUT US</p>
            <h1 className="share-circle-heading-left fw-bold">
              What Is <span className="share-support-text">Share Circle</span>
            </h1>

            <ul className="share-circle-description-list-icon ps-3">
              <li>
                Bitcoin Community Leaders & Share-Circle enable efficient,
                low-cost local lending.
              </li>
              <li>0% interest loans</li>
              <li>In Bitcoin communities</li>
              <li>Operated by local Community partners (CSPs)</li>
              <li>Using a central digital platform</li>
              <li>Uses a crowd fund model to build collateral</li>
              <li>10% contribution to CSPs</li>
              <li>Repaid funds are re-lent through the system</li>
              <li>The system capacity to lend, grows over time</li>
              <li>Core funds held in Bitcoin, lent out funds are in Fiat</li>
            </ul>

            <div className="mt-3">
              <a href="/learnmore" className="btn donate-button">
                Learn More
              </a>
            </div>
          </div>

          {/* RIGHT: Text Section */}
          <div className="col-12 col-lg-6 d-flex flex-column right-column-border position-relative z-1 bg-white bg-opacity-75 p-4 rounded">
            <div className="torn-image-background w-100 position-relative d-flex justify-content-center align-items-center p-3">
              <img
                style={{ maxWidth: "400px" }}
                src="./images/logo12.png"
                className="main-children-image img-fluid "
                alt="Children"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionOne;
